import React, { useContext } from 'react'
import {
    Grid,
    InputLabel,
    Select,
    useMediaQuery,
    useTheme,
    makeStyles,
} from '@material-ui/core';

import { StyledFormControl } from '../common/CustomComponents'
import { IncomeTaxContext } from './IncomeTax'
import { getTaxYearIndex, getCurrentTaxYearIndex } from '../../core/calculatorUtils';

const useStyles = makeStyles(theme => {
    return {
        active: {
            width:'100%',

            '& .MuiSelect-root': {
            backgroundColor: theme.palette.primary.main,
            },

            '& .MuiInputLabel-root': {
                color: theme.palette.primary.contrastText,
                fontWeight: 700,
            },
            '& .MuiSelect-underline:before, .MuiFilledInput-underline:before': {
                borderColor: theme.palette.primary.light,
            },
        },
        inactive: {
            width:'100%',
        },
    }
});


export const TaxInputOptions = () => {
    const { year, setCurrentYear, taxCategories, category, setCategory } = useContext(IncomeTaxContext);

    const theme = useTheme();
    const classes = useStyles()
    const small = useMediaQuery(theme.breakpoints.down('xs'));

    const yearIndex = getTaxYearIndex(year);
    const yearIndexCurrent = getCurrentTaxYearIndex();

    const currentCategories = taxCategories.find(c => c.year === year);

    const handleChangeYear = () => event => {
        setCurrentYear(event.target.value)
    }

    const handleChangeCategory = () => event => {
        setCategory(event.target.value)
    }


    return (
        <Grid container spacing={small ? 1 : 4} >
            <Grid item xs={7} md={8}>
                <StyledFormControl variant="filled" fullWidth >
                    <InputLabel htmlFor="taxCategoryTaxInfo">Tax category</InputLabel>
                    <Select
                        native
                        variant="filled"
                        id="taxCategoryTaxInfo"
                        onChange={handleChangeCategory()}
                        aria-label='tax category tax info'
                        value={category}
                    >
                        {currentCategories.categories.map((option, index) => (
                            <option
                                key={option}
                                data={option}
                            >
                                {option}
                            </option>
                        ))}
                    </Select>
                </StyledFormControl>
            </Grid>
            <Grid item xs={5} md={4}>
                <StyledFormControl variant="filled" fullWidth className = {yearIndex === yearIndexCurrent ? classes.inactive : classes.active} >
                    <InputLabel aria-label="Tax year" htmlFor="yearTaxInfo">Tax year</InputLabel>
                    <Select
                        native
                        variant="filled"
                        id="yearTaxInfo"
                        onChange={handleChangeYear()}
                        aria-label='year tax info'
                        aria-labelledby="Tax year"
                        value={year}
                    >
                        {taxCategories.map((option, index) => (
                            <option
                                key={option.year + " " + index}
                                aria-labelledby="Tax year"
                                data={option.year}
                                value={option.year}
                            >
                                {`${Number(option.year) - 1} - ${option.year - 2000}`}
                            </option>
                        ))}
                    </Select>
                </StyledFormControl>
            </Grid></Grid>
    )
}
